export default {
  Code128: 'code128',
  Code39: 'code39',
}
